<template>
  <div :class="classnames">
    <modal-hitzone @click="handleHitzoneClick">
      <modal-control :isOpen="isOpen">
        <slot name="control" />
      </modal-control>
    </modal-hitzone>

    <modal-area :isOpen="isOpen">
      <modal-content :isOpen="isOpen" :viewName="viewName">
        <component :is="viewName" v-bind="viewProps" @closeModal="close" />
      </modal-content>
    </modal-area>
  </div>
</template>

<script>
  import _has from 'lodash/has'

  import ModalArea from './ModalArea'
  import ModalContent from './ModalContent'
  import ModalControl from './ModalControl'
  import ModalHitzone from './ModalHitzone'
  import ModalViewSearch from './ModalViewSearch'
  import ModalViewShare from './ModalViewShare'

  import HtmlClassnames from '@/utils/htmlClassnames.js'
  import { bem } from '@/mixins/bem.js'
  import { EventBus } from '@/utils/eventBus.js'

  const namespace = 'modal'

  const modifiers = {
    isOpen: 'is-open'
  }

  export default {
    name: 'Modal',
    mixins: [ bem ],
    components: {
      'modal-area': ModalArea,
      'modal-content': ModalContent,
      'modal-control': ModalControl,
      'modal-hitzone': ModalHitzone,
      'modal-view-search': ModalViewSearch,
      'modal-view-share': ModalViewShare
    },
    data: function () {
      return {
        isOpen: false, // hardcode to true when dev'n
        viewName: null, // hardcode to 'view-name' when dev'n
        viewProps: null
      }
    },
    watch: {
      isOpen: function () {
        this.$emit('openchange', this.isOpen)
      }
    },
    created: function () {
      this.namespace = namespace

      if (this.isOpen) {
        HtmlClassnames.add('modal-open')
      }

      const that = this

      EventBus.$on('openmodal', function (viewName, viewProps) {
        const viewExists = that.hasView(viewName, viewProps)

        if (viewExists) {
          that.open(viewName, viewProps)
        }
      })
    },
    methods: {
      classnameModifiers: function () {
        const isOpen = this.isOpen && modifiers.isOpen

        return [
          isOpen
        ]
      },
      close: function () {
        this.isOpen = false

        HtmlClassnames.remove('modal-open')

        this.resetView()
      },
      handleHitzoneClick: function () {
        this.toggleOpenState()
      },
      open: function (viewName, viewProps) {
        this.isOpen = true

        HtmlClassnames.add('modal-open')

        this.setView(viewName, viewProps)
      },
      resetView: function () {
        this.viewName = null
        this.viewProps = null
      },
      setView: function (viewName, viewProps) {
        this.viewName = viewName
        this.viewProps = viewProps
      },
      toggleOpenState: function () {
        const isOpen = this.isOpen

        if (isOpen) {
          this.close()
        } else {
          this.open()
        }
      },
      hasView: function (viewName, viewProps) {
        if (!viewName || !viewProps) {
          return false
        }

        const {
          components
        } = this.$options

        if (_has(components, viewName)) {
          return true
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Modal/Modal.vue